import { createAction, props } from '@ngrx/store';
import { EngagementVisitor } from '../../models/engagement-visitor.model';

export const visitorEngagedSuccess = createAction(
    '[Engagements] Engage Visitor Success',
    props<{
        visitor: EngagementVisitor;
    }>(),
);
